import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref } from "vue"

const _hoisted_1 = { class: "w-full relative font-montserrat" }
const _hoisted_2 = {
  key: 0,
  class: "bg-red-600 border border-red-600 my-[10px] text-white text-center fixed md:top-[80px] top-[60px] shadow-lg left-[50%] translate-x-[-50%] font-bold flex justify-center items-center z-30 rounded-[5px] max-w-[450px] w-[90%] p-[20px]"
}
const _hoisted_3 = { class: "relative pt-[70px] w-full mb-[50px]" }
const _hoisted_4 = { class: "flex justify-end items-center" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "w-full relative py-[10px] flex justify-center items-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "w-full py-[20px] flex justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-center font-bold text-sm" }, "© 2023 Cotonou Cadjehoun, Tous droits réservés.")
], -1)

import headerComponent from '@/components/headerComponentAdmin.vue';
import { ref, onMounted } from 'vue';
import axios from 'axios';
import { useRouter } from 'vue-router';
import { QuillEditor, Quill } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import axiosInstance from '@/plugins/axios';

import BlotFormatter from "quill-blot-formatter/dist/BlotFormatter";



export default /*#__PURE__*/_defineComponent({
  __name: 'AddAnMail',
  setup(__props) {

const modules = {
  name: "blotFormatter",
  module: BlotFormatter,
  options: {/* options */},
}

const loading = ref(false);
const loading1 = ref(false);
const loading2 = ref(false);
const router = useRouter();
const pageTitle = ref('Add an mail');

const content = ref('');
const object = ref('');
const selectedFile = ref(null);
const errorMessage = ref("");

const isUpdateRoute = router.currentRoute.value.path.includes("/AddAnMail/") && router.currentRoute.value.params.id;
const isNewRoute = router.currentRoute.value.path === "/AddAnMail";

const selectedMail = ref(null);



onMounted(() => {
    document.title = pageTitle.value;
});

const handleFileChange = (event: any) => {
  selectedFile.value = event.target.files[0];
};

const updateContent = (value: any) => {
  content.value = value;
};

let userId = ref(null);

const saveMail = async () => {
  try {
    loading1.value = true;
    const token = localStorage.getItem('token');
    if (!token) return;


    const userResponse = await axiosInstance.get('/auth/users/me/', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    userId.value = userResponse.data.id;

    const formData = new FormData();
    formData.append('object', object.value);
    formData.append('content', content.value);

    if (selectedFile.value) {
      formData.append('stylesheet', selectedFile.value);
    };

    const response = await axiosInstance.post('/mailings/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`,
      },
    });

    let newMailId ;

    if (response.status === 200 || response.status === 201 || response.status === 204) {
      const newMailId = response.data.id; 
    }
    router.push('/ListOfMails');
  } catch (error) {
    if(error.response && error.response.status && error.response.status == 400) {
      if(error.response.data && error.response.data.stylesheet) {
        errorMessage.value = "uploaded file: " + error.response.data.stylesheet[0]
      } else if(error.response.data && error.response.data.object) {
        errorMessage.value = "object: " + error.response.data.object[0]
      } else if(error.response.data && error.response.data.content) {
        errorMessage.value = "content: " + error.response.data.content[0]
      } else {
        errorMessage.value = "Unknow error"; 
      }
    } else {
      errorMessage.value = 'Erreur lors de la création ou du sauvegarde de l\'mail';
    }
    
    hideErrorMessageAfterDelay();
  } finally {
    loading1.value = false;
  }
};

const hideErrorMessageAfterDelay = () => {
  setTimeout(() => {
    errorMessage.value = ''; 
  }, 5000);
};

onMounted(() => {
  document.title = pageTitle.value;
  const MailId = router.currentRoute.value.params.id;

  if (MailId) {
    loadMailDetails(MailId);
    pageTitle.value = 'Edit an mail';
  }
});

const loadMailDetails = async (id: number) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) return;

    const response = await axiosInstance.get(`/mailings/${id}/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const mail = response.data;
    selectedMail.value = mail;
    object.value = mail.object;
    content.value = mail.content;
  } catch (error) {
    errorMessage.value = 'Erreur lors du chargement des détails de l\'mail';
    hideErrorMessageAfterDelay();
  }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(headerComponent),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        isNewRoute
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("button", {
                disabled: loading1.value,
                class: "text-sm font-bold rounded-[5px] min-w-[60px] p-[10px] border border-gray-400 m-[10px] bg-cyan-800 text-white shadow-lg",
                onClick: saveMail
              }, [
                (loading1.value)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                  : (_openBlock(), _createElementBlock("span", _hoisted_8, "Send mail"))
              ], 8, _hoisted_6)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", null, [
          _createElementVNode("input", {
            type: "file",
            onChange: handleFileChange,
            class: "m-[10px] max-w-[calc(100%-52%)] p-[10px]"
          }, null, 32)
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((object).value = $event)),
          class: "m-[10px] w-full relative p-[10px] border border-gray-400 rounded-[5px] outline-none",
          placeholder: "Enter mail object"
        }, null, 512), [
          [_vModelText, object.value]
        ])
      ]),
      _createVNode(_unref(QuillEditor), {
        content: content.value,
        "onUpdate:content": _cache[1] || (_cache[1] = ($event: any) => ((content).value = $event)),
        "content-type": "html",
        theme: "snow",
        toolbar: "full",
        required: "yes",
        modules: modules
      }, null, 8, ["content"])
    ]),
    _hoisted_10
  ]))
}
}

})